import { render, staticRenderFns } from "./SubjectTeacherImport.vue?vue&type=template&id=3df38794"
import script from "../../controllers/subject_teacher/subject-teacher-import.js?vue&type=script&lang=js&external"
export * from "../../controllers/subject_teacher/subject-teacher-import.js?vue&type=script&lang=js&external"
import style0 from "./SubjectTeacherImport.vue?vue&type=style&index=0&id=3df38794&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports